export default function TypingIndicator({ users }) {
  if (!users || users.length === 0) return null;
  const label =
    users.length === 1
      ? `${users[0]} sedang mengetik`
      : users.length === 2
      ? `${users[0]} dan ${users[1]} sedang mengetik`
      : `${users.length} orang sedang mengetik`;

  return (
    <div
      data-testid="typing-indicator-container"
      className="flex items-center gap-2 px-4 py-1.5 text-xs text-indigo-300/90 font-medium italic"
    >
      <span className="flex items-center gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-indigo-400 animate-bounce"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </span>
      {label}
    </div>
  );
}
